import React from 'react';
import {
  Box,
  BackgroundImage,
  Flex,
} from '@edreamsodigeo/prisma-design-system';
import ValuePropositionHeader from './components/ValuePropositionHeader';
import ValuePropositionList from './components/ValuePropositionList';
import ValuePropositionFooter from './components/ValuePropositionFooter';
import getBrandedImage from '~/utils/getBrandedImage';
import { useBrand } from '@edreamsodigeo/frontend-core';

const ValuePropositionDesktop = () => {
  const brand = useBrand();
  const backgroundImage = `url("${getBrandedImage(
    'BSA_images_SA.png',
    brand,
    '/images/SEP/SA/'
  )}")`;
  return (
    <Box
      backgroundColor="primary.20"
      width="100%"
      height="100%"
      minWidth="455px"
    >
      <BackgroundImage
        backgroundImage={backgroundImage}
        backgroundRepeat="no-repeat"
        backgroundPosition={`calc(100% + 30px) calc(100% + 30px)`}
        backgroundSize="200px"
      >
        <Flex flexDirection="column" py="huge" px="2x_big" height="100%">
          <ValuePropositionHeader />
          <Box maxWidth="85%" mt="2x_big">
            <ValuePropositionList />
          </Box>
          <Box maxWidth="55%" mt="auto" pt="2x_big">
            <ValuePropositionFooter />
          </Box>
        </Flex>
      </BackgroundImage>
    </Box>
  );
};

export default ValuePropositionDesktop;
